import React from 'react';
import { useFormikContext } from 'formik';
import styles from './SendEmailForm.module.scss';
import TextEditor from 'component/atom/forms/text-editor/TextEditor';
import Input from 'component/atom/forms/input/input/Input';

const SendEmailForm = () => {
  const formik = useFormikContext();

  return (
    <form
      className={styles['message-form']}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <div className={styles['editor-container']}>
        <Input
          placeholder='Enter Email'
          label='To'
          value={formik.values.emailTo}
          name='emailTo'
          onChange={(e) => formik.setFieldValue('emailTo', e.target.value)}
          error={formik.errors.emailTo}
          touched={formik.touched.emailTo}
          onBlur={formik.handleBlur}
        />
        <Input
          placeholder='Enter Subject'
          label='Subject'
          value={formik.values.subject}
          name='subject'
          onChange={(e) => formik.setFieldValue('subject', e.target.value)}
          error={formik.errors.subject}
          touched={formik.touched.subject}
          onBlur={formik.handleBlur}
        />
        <TextEditor
          placeholder='Enter your custom message...'
          name='body'
          value={formik.values.body}
          onChange={(value) => formik.setFieldValue('body', value)}
          error={formik.errors.body}
          touched={formik.touched.body}
          rows='15'
          className={styles['editor']}
          isCustom
          isToolbarReduced
          textEditorClassName={styles['editor-class']}
        />
      </div>
    </form>
  );
};

export default SendEmailForm;
